/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AssignShiftOwnerActionType {
    Assign = 1,
    Handover = 2,
    TakeOwnership = 3,
}
